import { combineReducers } from '@reduxjs/toolkit'
import { History } from 'history'

import app from './application/slice'
import auth from './auth/slice'
import candidateJobs from './candidate/slice'
import Centres from './centers/slice'
import dashboard from './dashboard/slice'
import enquiry from './enquiry/slice'
import onboarding from './onboarding/slice'
import referrals from './superadmin/referral/slice'
import superadmin from './superadmin/slice'
import timesheet from './timesheet/slice'
import uploads from './uploads/slice'
import vacancy from './vacancy/slice'

const RootReducer = (history: History) =>
  combineReducers({
    auth,
    app,
    dashboard,
    onboarding,
    uploads,
    enquiry,
    superadmin,
    referrals,
    Centres,
    vacancy,
    candidateJobs,
    timesheet
  })

export default RootReducer
